var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.086,
    y1: -4.05,
    x2: 0.086,
    y2: -3.069,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8959c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a27ccf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.496,
    y1: -3.559,
    x2: 0.484,
    y2: -3.559,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ffb1db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd86c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.691,
    y1: 0.696,
    x2: 0.334,
    y2: 0.706,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d85099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8048be"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(-1743.124 448.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-2",
    "data-name": "logo",
    transform: "translate(1754 -442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M66.641,4.336l11.866,68.1-11.866,58.01A34.674,34.674,0,0,1,7.313,98.8,26.592,26.592,0,0,1,15.46,56.295,26.579,26.579,0,0,1,36.674,15.477,18.352,18.352,0,0,1,66.641,4.336Z",
    transform: "translate(0.027 -0.004)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M109.829,98.748A34.648,34.648,0,0,1,50.5,130.39V4.336A18.352,18.352,0,0,1,80.467,15.477a26.579,26.579,0,0,1,21.095,40.765,26.592,26.592,0,0,1,8.266,42.506Z",
    transform: "translate(16.115 -0.004)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M36.2,29.433a18.313,18.313,0,0,1-7.528-14.819A18.788,18.788,0,0,1,28.9,11.74a26.5,26.5,0,0,0-4.377.58,21.9,21.9,0,0,0-.119,2.294,22.6,22.6,0,0,0,9.229,18.247,2.127,2.127,0,1,0,2.518-3.428Z",
    transform: "translate(7.805 3.733)",
    fill: "#8048be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M30.917,89.363a22.585,22.585,0,0,0-2.022-5.11,26.242,26.242,0,0,0,6.442-12.534,1.962,1.962,0,0,0-3.839-.775A22.549,22.549,0,0,1,11.4,88.806a1.951,1.951,0,1,0,.157,3.9h.17a26.3,26.3,0,0,0,14.193-5.643,18.165,18.165,0,0,1,1.211,3.33,18.577,18.577,0,0,1-1.962,14.2,1.962,1.962,0,1,0,3.379,1.986A22.512,22.512,0,0,0,30.966,89.4Z",
    transform: "translate(4.214 28.712)",
    fill: "#8048be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M30.6,55.295C23.2,54.013,14.687,47.54,10.862,40.535a20.771,20.771,0,0,0-2,4.8A31.131,31.131,0,0,0,29.874,59.487a2.127,2.127,0,1,0,.725-4.193Z",
    transform: "translate(-7.689 27.404)",
    fill: "#8048be"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(88.503 15.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M67.917,29.433a18.3,18.3,0,0,0,7.541-14.819,18.789,18.789,0,0,0-.224-2.874,26.368,26.368,0,0,1,4.364.58,21.9,21.9,0,0,1,.119,2.294,22.6,22.6,0,0,1-9.229,18.247,2.127,2.127,0,1,1-2.518-3.428Z",
    transform: "translate(-67.102 -11.74)",
    fill: "#d85099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M75.167,109.669a1.954,1.954,0,1,0,3.365-1.978,18.549,18.549,0,0,1-2.014-14.147,18.09,18.09,0,0,1,1.206-3.317,26.159,26.159,0,0,0,14.135,5.656h.193A1.943,1.943,0,1,0,92.208,92,22.456,22.456,0,0,1,72.176,74.248a1.954,1.954,0,0,0-3.823.772,26.231,26.231,0,0,0,6.4,12.494,23.046,23.046,0,0,0-2,5.041A22.372,22.372,0,0,0,75.167,109.669Z",
    transform: "translate(-65.51 11.656)",
    fill: "#d85099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M76.146,55.285c7.4-1.278,16.022-7.637,19.739-14.718a32.356,32.356,0,0,1,1.978,4.759A31.121,31.121,0,0,1,76.871,59.477a2.127,2.127,0,0,1-.725-4.193Z",
    transform: "translate(-54.237 11.941)",
    fill: "#d85099"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "speed_black_24dp",
    transform: "translate(1780.512 -413.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M0,0H80.223V80.223H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M60.364,24.1a3.343,3.343,0,0,0-.234,3.343,25.236,25.236,0,0,1,1.738,6.05,26.741,26.741,0,0,1-2.306,15.811,3.343,3.343,0,0,1-2.975,1.772H14.3a3.343,3.343,0,0,1-2.975-1.805,26.741,26.741,0,0,1,27.443-38.34A25.7,25.7,0,0,1,45.824,12.8,3.36,3.36,0,1,0,48.6,6.687a33.426,33.426,0,0,0-42.083,47.5,6.685,6.685,0,0,0,5.749,3.343h46.3a6.685,6.685,0,0,0,5.816-3.343A33.426,33.426,0,0,0,66.214,24.47a3.343,3.343,0,0,0-5.85-.368Z",
    transform: "translate(4.683 9.324)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M12.01,25.849a6.627,6.627,0,0,0-.548,9.727c2.612,2.612,6.661,2.751,10.007-.267L40.389,6.93Z",
    transform: "translate(23.388 16.234)",
    fill: "url(#linear-gradient-3)"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 155,
    height: 155,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.afb69a3b05355042c9b2b364e1bdb557.svg";
export { ForwardRef as ReactComponent };